import { render, staticRenderFns } from "./TemplateBatchUpdateDialog.vue?vue&type=template&id=636b833a&scoped=true&"
import script from "./TemplateBatchUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./TemplateBatchUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b833a",
  null
  
)

export default component.exports